/*

  Bestdisplay.ts

  Best words and games display component

  Copyright (C) 2024 Miðeind ehf.
  Author: Vilhjalmur Thorsteinsson

  The Creative Commons Attribution-NonCommercial 4.0
  International Public License (CC-BY-NC 4.0) applies to this software.
  For further information, see https://github.com/mideind/Netskrafl

*/

import { ts } from "./i18n";
import { ComponentFunc, VnodeChildren, m } from "./mithril";

interface IAttributes {
  ownStats: Record<string, any>;
  myself: boolean;
  id: string;
}

export const BestDisplay: ComponentFunc<IAttributes> = () => {
  // Display the best words and best games played for a given user

  return {

    view: (vnode) => {
      // Populate the highest score/best word field
      const json = vnode.attrs.ownStats || {};
      const best: VnodeChildren = [];
      if (json.highest_score) {
        best.push(ts("Hæsta skor "));
        best.push(m("b",
          m(m.route.Link,
            { href: "/game/" + json.highest_score_game },
            json.highest_score
          )
        ));
      }
      if (json.best_word) {
        if (best.length)
          if (vnode.attrs.myself)
            best.push(m("br")); // Own stats: Line break between parts
          else
            best.push(" | "); // Opponent stats: Divider bar between parts
        let bw = json.best_word;
        let s = [];
        // Make sure blank tiles get a different color
        for (let i = 0; i < bw.length; i++)
          if (bw[i] == '?') {
            s.push(m("span.netskrafl-blanktile", bw[i + 1]));
            i += 1;
          }
          else
            s.push(bw[i]);
        best.push(ts("Besta orð "));
        best.push(m("span.best-word", s));
        best.push(", ");
        best.push(m("b",
          m(m.route.Link,
            { href: "/game/" + json.best_word_game },
            json.best_word_score
          )
        ));
        best.push(ts(" stig"));
      }
      return m("p", { id: vnode.attrs.id }, best);
    }

  };
}
